import React from 'react';

const Header = () => {
  return (
    <header>
      <p className='bio'> Hi! I'm a Computer Science graduate with hands-on experience in software engineering and web
 development. <br></br>Have a look around to see what I have done in my undergrad and who I've interned for. </p>
   
    </header>
  );
};

export default Header;
